import { on } from 'element-ui/lib/utils/dom'

export default {
  bind (el, binding, vnode) {
    let selector = binding.value.selector
    let handler = binding.value.handler

    if (selector && handler) {
      on(el, 'click', function (event) {
        let elements = el.querySelectorAll(selector)

        for (let element of elements) {
          if (element.contains(event.target)) {
            return
          }
        }

        handler()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/clickinside.js